<template>
    <section class="bg-primary py-5 overflow-hidden" id="Intro">
        <div class="container flex flex-wrap py-5">
            <div class="row mb-5 d-flex flex-wrap">
                <div class="col-lg-4 col-4 wow slideInLeft">
                    <div class="card border-0 bg-transparent text-center hover-img">
                        <img src="assets/img/epigenetic-1.png" class="card-img-top" alt="...">
                    </div>
                </div>
                <div class="col-lg-4 col-4 wow slideInUp">
                    <div class="card border-0 bg-transparent text-center hover-img">
                        <img src="assets/img/epigenetic-2.png" class="card-img-top" alt="...">
                    </div>
                </div>
                <div class="col-lg-4 col-4 wow slideInUp">
                    <div class="card border-0 bg-transparent text-center hover-img">
                        <img src="assets/img/epigenetic-3.png" class="card-img-top" alt="...">
                    </div>
                </div>
                <div class="col-12 text-white text-content text-center wow">
                    <p class="pt-1" v-html="sectionNad2.title"></p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios'

export default {
  name: 'SectionNad2',

  data(){
   return{
     lastScrollPosition: 0,
     sectionNad2:{
         title: null
         }
   }
 },

  mounted(){
    axios.get(`../../lang.json`).then(response => {
            let dataSectionnad2
            if (localStorage.getItem('lang_nad') == 'id'){
                dataSectionnad2 = response.data.id[0];
            } else if(localStorage.getItem('lang_nad') == 'en'){
                dataSectionnad2 = response.data.en[0];
            }
            this.sectionNad2.title = dataSectionnad2.sectionNad2.title
            })

    window.addEventListener('scroll', this.onScroll)
  }
}
</script>
